import TextAlignToolbarView from "./TextAlignToolbarView.vue";
import {TextAlign as TextAlignExtension} from "@tiptap/extension-text-align";

export default class TextAlign {

    constructor() {
        this.toolbarView = TextAlignToolbarView;
    }

    static create() {
        return new TextAlign();
    }

    getExtensions() {
        return [TextAlignExtension.configure({
            types: ["heading", "paragraph", "image", "videoEmbed"]
        })];
    }
}